const USER = {
  TYPES: {
    ADMIN: 'ADMIN',
    USER: 'USER',
    QUARENTINE: 'QUARENTINE',
  },
};

export default USER;
